import { DOCUMENT_KEYS } from '@views/ProofDocuments/components';
import { useGetDocumentsInfoQuery } from '@views/ProofDocuments/graphql';
import { useParseDocumentInfo } from '@views/ProofDocuments/hooks';
import { useMemo } from 'react';

export const useController = () => {
  const { data, loading: isLoading } = useGetDocumentsInfoQuery();
  const { parseDocByType } = useParseDocumentInfo();

  const documents = useMemo(() => data?.activeRequisition?.documents || [], [data]);
  const requisitionStatus = data?.activeRequisition?.status || '';
  const paymentFrequency = useMemo(() => data?.activeRequisition?.income?.paymentFrequency || '', [data]);

  const docsData = useMemo(() => ({
    payslip: parseDocByType({
      documents,
      type: DOCUMENT_KEYS.PAYSLIP,
      paymentFrequency,
      requisitionStatus,
    }),
    bankStatement: parseDocByType({
      documents,
      type: DOCUMENT_KEYS.BANK_STATEMENT,
      paymentFrequency,
      requisitionStatus,
    }),
  }), [
    documents,
    parseDocByType,
    paymentFrequency,
    requisitionStatus,
  ]);

  return {
    isLoading,
    requisitionStatus,
    ...docsData,
  };
};
